export enum columnsEnum {
	modalsButtons = '',
	customColonne = 'customColonne'
}

export const getKeyFromColumnValue = (value: columnsEnum) =>
	Object.keys(columnsEnum).find(
		(columnKey) => columnsEnum[columnKey as keyof typeof columnsEnum] === value
	) ?? ''
